<template>
  <div>
    <v-toolbar color="#0a3444" class="top-toolbar">
      <v-spacer></v-spacer>

      <div class="btn-group">
        <v-btn-toggle v-model="sort" mandatory>
          <v-btn flat value="caseasc">
            <span>Cases</span>
            <v-icon>arrow_upward</v-icon>
          </v-btn>
          <v-btn flat value="casedesc">
            <span>Cases</span>
            <v-icon>arrow_downward</v-icon>
          </v-btn>
          <v-btn flat value="vehicleasc">
            <span>Vehicles</span>
            <v-icon>arrow_upward</v-icon>
          </v-btn>
          <v-btn flat value="vehicledesc">
            <span>Vehicles</span>
            <v-icon>arrow_downward</v-icon>
          </v-btn>
        </v-btn-toggle>
      </div>

      <v-toolbar-items>
        <v-menu
          v-model="menu"
          :close-on-content-click="false"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="date"
              prepend-inner-icon="event"
              readonly
              v-on="on"
              solo
              class="toolbar-item"
            ></v-text-field>
          </template>
          <v-date-picker v-model="date" @input="menu = false"></v-date-picker>
        </v-menu>
        <v-combobox 
          solo 
          class="toolbar-item" 
          v-model="selectedGroup" 
          item-text="Name" 
          item-value="Id" 
          :items="group" 
          label="Group" 
          @change="handleChangeGroup">
        </v-combobox>
        <v-combobox 
          solo 
          class="toolbar-item" 
          v-model="selectedStatus"
          :items="optionsStatus" 
          label="Trạng Thái" 
          @change="handleChangeStatus"
        >
        </v-combobox>
        <v-text-field
          v-model="keyword"
          @change="search"
          label="Tìm kiếm"
          solo
          class="toolbar-item"
          small
        ></v-text-field>
      </v-toolbar-items>
    </v-toolbar>

    <div class="gantt">
      <div class="gantt__row gantt__row--months">
        <div class="gantt__row-first"></div>
        <span v-for="i in 24" :key="i" v-show="i >= 8 && i<= 20">{{i}}:00</span>
      </div>
      <div class="gantt__row gantt__row--lines" data-month="5">
        <span v-for="i in 24" :key="i" v-show="i >= 8 && i<= 20" :class="displayCurrentTime(i)"></span>
      </div>
      <div
        class="gantt__row"
        v-for="(supporter, index) in datasourceFiltered"
        :key="index"
        v-show="supporter.Name"
      >
        <div class="gantt__row-first">
          <div class="d-flex align-start">
            <p class="sup-name mb-0">G{{supporter.Group}} - {{supporter.Name}}</p>
            <v-icon size="16px" :color="supporter.WorkingStatus === workingStatus.Ready ? 'green' : 'grey'" class="mr-1">
              fiber_manual_record
            </v-icon>
          </div>
          <p class="para">Cases: {{ countCaseBySupporter(supporter) }}</p>
          <p
            class="para"
          >Vehicles: {{ countVehicleBySupporter(supporter)[1] }} New / {{ countVehicleBySupporter(supporter)[2] }} SC</p>
          <p v-if="supporter.MorningOffline === 'True'" class="pl-2 text-xs-left red--text">Nghỉ buổi sáng</p>
          <p v-if="supporter.AfternoonOffline === 'True'" class="pl-2 text-xs-left red--text">Nghỉ buổi chiều</p>
        </div>
        <ul class="gantt__row-bars" v-if="supporter && supporter.Cases">
          <li
            v-for="(task, index2) in supporter.Cases.filter(a => moment(a.Plan).format('YYYY-MM-DD') === moment(date).format('YYYY-MM-DD') && a.RepairPerson)"
            :key="index2"
            :style="getTaskDuration(task)"
            :class="`${getTaskColor(task)} stripes`"
          >
            <template>
              <div class="text-xs-center">
                <v-menu :close-on-content-click="false" :nudge-width="200" offset-x>
                  <template v-slot:activator="{ on }">
                    <label v-on="on" class="case-number-label">#{{task.TicketCode}}</label>

                    <label v-on="on" class="case-driving">
                      <br />
                      {{moment(task.Plan).format('HH:mm')}} -
                      {{moment(task.Plan).add(task.InstallationDuration, 'minutes') .format('HH:mm')}}
                    </label>

                    <label v-on="on" class="case-driving">
                      <br />
                      {{`${task.Type === 'New' ? 'New' : 'SC'}`}}
                      {{task.TrackerQty}}
                      <v-icon
                        class="vehicle-icon"
                        dark
                        v-show="task.TrackerQty > 0"
                      >directions_car</v-icon>
                    </label>
                  </template>
                  <v-card>
                    <v-card-text>
                      <h5>
                        <a :href="urlCRMBitrix(task.Id)" target="_blank">#{{task.TicketCode}}</a>
                      </h5>
                      <p class="task-detail">{{task.Vehicle}}</p>
                      <p class="task-detail">Repair Location: {{task.RepairLocation}}</p>
                      <p class="task-detail">Location: {{task.Location}}</p>
                      <p
                        class="task-detail"
                      >Plan: {{ getTimeFromPlan(task.Plan).format("YYYY-MM-DD, HH:mm:ss")}}</p>
                      <p class="task-detail">Duration: {{task.InstallationDuration}} min</p>
                      <p class="task-detail">Repair person: {{supporter.Name}}</p>
                      <p class="task-detail">Repair person list: {{task.RepairPersonList}}</p>
                      <p class="task-detail">Type: {{task.Type}}</p>
                      <p
                        class="task-detail"
                        v-show="task.Finished"
                      >Finished: {{ getTimeFromPlan(task.Finished).format('YYYY-MM-DD, HH:mm:ss')}}</p>
                    </v-card-text>
                  </v-card>
                </v-menu>
              </div>
            </template>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import moment, { lang } from 'moment';
import { mapActions, mapMutations, mapGetters } from 'vuex';
import validate from '@/utils/validate';
import { urlCRMBitrix, WorkingStatus } from '@/utils/index';

export default {
  props: {
    // supporters: Array
  },
  data () {
    return {
      datasource: [],
      datasourceFiltered: [],
      moment: moment,
      menu: false,
      date: moment().format('YYYY-MM-DD'),
      sort: 'casedesc',
      keyword: '',
      group: [],
      selectedGroup: null,
      inititalSupporters: [],
      workingStatus: WorkingStatus,
      optionsStatus: ['Offline', 'Online'],
      selectedStatus: ''
    };
  },

  computed: {
    ...mapGetters(['supporters'])
  },

  watch: {
    sort () {
      localStorage.setItem('sort', this.sort);
      this.sortSupporters(this.sort);
    },
    // supporters () {
    //   this.datasource = this.supporters;
    //   this.search();
    // },
    selectedGroup () {
      // localStorage.setItem('selectedGroup', this.selectedGroup);
      // this.search();
      // this.getTickets();
    },

    date () {
      this.getTickets();
    }
  },

  // created () {
  // },

  async mounted () {
    this.CLEAR_DATA();
    this.inititalSupporters = await this.GetAllTechnicalUser();
    let selected = localStorage.getItem('selectedGroup');
    this.selectedGroup = selected ? JSON.parse(selected) : null;

    let sort = localStorage.getItem('sort');
    this.sort = sort ? sort : 'casedesc';

    await this.getGroup();
    await this.getTickets();
  },
  methods: {
    ...mapActions(['GetSupporters', 'GetUserGroup', 'GetTicketByDate', 'GetAllTechnicalUser']),
    ...mapMutations(['SET_CASE_TO_SUPPORTERS', 'CLEAR_DATA']),
    urlCRMBitrix,

    displayCurrentTime (index) {
      let now = moment().hour();
      return index === ++now ? 'marker' : '';
    },

    getTaskDuration (task) {
      if (task.Plan) {
        let start = moment(task.Plan).subtract(7, 'h');
        let end = moment(start).add(task.InstallationDuration, 'minutes');
        let startHour = start.hour();
        let endHour = end.hour();

        return `grid-column: ${startHour}/${endHour}`;
      }
    },
    // eslint-disable-next-line complexity
    getTaskColor (task) {
      if (task.Status === 'Closed') return 'grey';
      // if (task.Type === 'Rest') {
      //   return 'transparent';
      // } 
      // else if (task.Type === 'New') {
      //   return 'error';
      // } 
      if ((task.Status === 'RePlan' || task.Status === 'Re-Plan') && task.RePlanTime) {
        return 'deep-purple lighten-2';
      } else if (
        task.Started &&
        task.Finished &&
        task.Status !== 'PendingInput' &&
        task.Status !== 'Closed'
      ) {
        return 'success';
      } else if (task.Started && !task.Finished && task.Status === 'Assigned') {
        if (task.DelayFinish === 'True') return 'indigo darken-3';
        return 'orange';
      } else if (
        task.Started &&
        task.Finished &&
        task.Status === 'PendingInput'
      ) {
        return 'deep-purple lighten-2';
      } else if (task.Started && task.Finished && task.Status === 'Closed') {
        return 'grey';
      } else if (
        task.WaitingFrom && 
        task.WaitingLocation && 
        !task.Started && 
        !task.Finished
        && task.Status !== 'Closed'
      ) { 
        return 'pink darken-1';
      }
      return 'blue';
    },
    getDateFromHour (hour) {
      // :08:00
      let h = hour.split(':')[0];
      let m = hour.split(':')[1];
      let d = moment(this.date);
      let date = new Date(d.year(), d.month(), d.date(), h, m, 0);
      return moment(date);
    },
    sortCaseByTime (sup) {
      sup.Cases.sort((a, b) => {
        let timeA = moment(a.Plan);
        let timeB = moment(b.Plan);
        return timeA - timeB;
      });
    },
    sortSupporters (sort) {
      switch (sort) {
        case 'caseasc': {
          this.datasourceFiltered.sort((a, b) => {
            let casesA = this.countCaseBySupporter(a);
            let casesB = this.countCaseBySupporter(b);
            return casesA - casesB;
          });
          break;
        }
        case 'casedesc': {
          this.datasourceFiltered.sort((a, b) => {
            let casesA = this.countCaseBySupporter(a);
            let casesB = this.countCaseBySupporter(b);
            return casesB - casesA;
          });
          break;
        }
        case 'vehicleasc': {
          this.datasourceFiltered.sort((a, b) => {
            let casesA = this.countVehicleBySupporter(a)[0];
            let casesB = this.countVehicleBySupporter(b)[0];
            return casesA - casesB;
          });
          break;
        }
        case 'vehicledesc': {
          this.datasourceFiltered.sort((a, b) => {
            let casesA = this.countVehicleBySupporter(a)[0];
            let casesB = this.countVehicleBySupporter(b)[0];
            return casesB - casesA;
          });
          break;
        }
        default:
          break;
      }
    },
    getPlanFromTime (time) {
      return time.add(-7, 'hours').format('YYYY-MM-DD HH:mm:ss');
    },
    getTimeFromPlan (plan) {
      return moment(plan);
    },
    getDurationFromCase (c) {
      if (!c.Finished) {
        return this.getTimeFromPlan(c.Plan).add(
          c.InstallationDuration,
          'minutes'
        );
      }
      return this.getTimeFromPlan(c.Finished);
    },
    countCaseBySupporter (sup) {
      if (sup && sup.Cases) {
        return sup.Cases.filter(
          a => this.getTimeFromPlan(a.Plan).format('YYYY-MM-DD') === moment(this.date).format('YYYY-MM-DD')
        ).length;
      }
      return 0;
    },
    countVehicleBySupporter (sup) {
      let newCount = 0;
      let repairCount = 0;

      if (sup && sup.Cases) {
        sup.Cases.filter(
          a => this.getTimeFromPlan(a.Plan).format('YYYY-MM-DD') === moment(this.date).format('YYYY-MM-DD')
        ).map(a => {
          if (a.TrackerQty) {
            if (a.Type === 'New') {
              newCount += Number(a.TrackerQty);
            } else {
              repairCount += Number(a.TrackerQty);
            }
          }
          return 0;
        });
      }

      return [newCount + repairCount, newCount, repairCount];
    },
    search () {
      let keywordRemovedVietnamese = this.keyword && validate.transferVietnamese(
        this.keyword.toLowerCase()
      );
      this.datasourceFiltered = this.datasource
        .filter(a =>
          a.Name && validate
            .transferVietnamese(a.Name.toLowerCase())
            .includes(keywordRemovedVietnamese.toLowerCase())
        )
        .reverse();

      if (this.selectedGroup) { this.datasourceFiltered = this.datasourceFiltered.filter(a => this.selectedGroup && a.Group === this.selectedGroup.Name) }
      if (this.selectedStatus) {
        console.log('🚀 ~ file: Tasks.vue ~ line 410 ~ search ~ this.selectedStatus', this.selectedStatus);
        if (this.selectedStatus === 'Online') { this.datasourceFiltered = this.datasourceFiltered.filter(a => a.WorkingStatus === this.workingStatus.Ready) }
        else { 
          this.datasourceFiltered = this.datasourceFiltered.filter(a => a.WorkingStatus !== this.workingStatus.Ready);
        }
      }
      // console.log('TCL: search -> this.selectedGroup', this.selectedGroup);
      // console.log('TCL: search -> this.selectedGroup', this.datasourceFiltered);

      this.sortSupporters(this.sort);
    },

    async getGroup () {
      let res = await this.GetUserGroup().catch(_ => {
        return [];
      });

      this.group = res || [];
      // console.log('🚀 ~ file: Tasks.vue ~ line 204 ~ getGroup ~ res', res);
      
    },

    async getTickets () {
      let params = {  
        date: this.date,
        groupId: this.selectedGroup && this.selectedGroup.Id
      };
      let cases = await this.GetTicketByDate(params);
      if (this.inititalSupporters && this.inititalSupporters.length > 0 && cases.length > 0) {
        this.SET_CASE_TO_SUPPORTERS();
      }

      this.datasource = [...this.supporters];
      this.search();
    },

    handleChangeGroup (data) {
      localStorage.setItem('selectedGroup', JSON.stringify(data));
      // this.selectedGroup = data;
      this.getTickets();
    },

    handleChangeStatus () {
      this.search();
    }
  }
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css?family=Roboto:100,400,700");
body,
html {
  font-family: "Roboto", sans-serif;
  background-color: #cddade;
  height: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.header {
  color: #202125;
  margin-bottom: 40px;
  h2 {
    font-weight: 600;
  }
  p {
    font-weight: 300;
  }
}
$red: #ff6252;
.wrapper {
  max-width: 1200px;
  min-width: 700px;
  margin: 0 auto;
  padding: 40px;
}
.gantt {
  display: grid;
  border: 0;
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
  //border-radius: 12px;
  // box-shadow: 0 75px 125px -57px #7e8f94;

  &__row {
    display: grid;
    grid-template-columns: 170px 1fr;
    background-color: #fff;
    &:nth-child(odd) {
      background-color: #f5f5f5;
      .gantt__row-first {
        background-color: #f5f5f5;
      }
    }
    &:nth-child(3) {
      .gantt__row-bars {
        border-top: 0;
      }
      .gantt__row-first {
        border-top: 0;
      }
    }
    &--empty {
      background-color: lighten($red, 25%) !important;
      z-index: 1;
      .gantt__row-first {
        border-width: 1px 1px 0 0;
      }
    }
    &--lines {
      position: absolute;
      height: 100%;
      width: 100%;
      background-color: transparent;
      grid-template-columns: 170px repeat(13, 1fr);
      span {
        display: block;
        border-right: 1px solid rgba(0, 0, 0, 0.1);
        &.marker {
          background-color: rgba(10, 52, 68, 0.2);
        }
      }
      &:after {
        grid-row: 1;
        grid-column: 0;
        background-color: #1688b345;
        z-index: 2;
        height: 100%;
      }
    }
    &--months {
      color: #0a3444;
      background-color: #ffffff !important;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      grid-template-columns: 170px repeat(13, 1fr);
      .gantt__row-first {
        border-top: 0 !important;
        background-color: #ffffff !important;
      }
      span {
        text-align: center;
        font-size: 13px;
        align-self: center;
        font-weight: bold;
        padding: 20px 0;
      }
    }
    &-first {
      background-color: #fff;
      border-width: 1px 0 0 0;
      border-color: rgba(0, 0, 0, 0.1);
      border-style: solid;
      padding: 15px 0;
      font-size: 13px;
      font-weight: bold;
      text-align: center;
    }
    &-bars {
      list-style: none;
      display: grid;
      padding: 9px 0;
      margin: 0;
      grid-template-columns: repeat(13, 1fr);
      grid-gap: 8px 0;
      border-top: 1px solid rgba(221, 221, 221, 0.8);
      li {
        font-weight: 500;
        text-align: center;
        font-size: 14px;
        min-height: 15px;
        background-color: #55de84;
        padding: 5px 12px;
        color: #fff;
        overflow: hidden;
        position: relative;
        //cursor: pointer;
        //border-radius: 20px;
        //height: 30px;

        &.stripes {
          background-image: repeating-linear-gradient(
            45deg,
            transparent,
            transparent 5px,
            rgba(255, 255, 255, 0.1) 5px,
            rgba(255, 255, 255, 0.1) 12px
          );
        }

        &:before,
        &:after {
          content: "";
          height: 100%;
          top: 0;
          z-index: 4;
          position: absolute;
          background-color: rgba(0, 0, 0, 0.3);
        }
        &:before {
          left: 0;
        }
        &:after {
          right: 0;
        }
      }
    }
  }

  &__head {
    &--left {
      float: left;
      padding: 4px 0px 0px 8px;
    }
    &--right {
      float: right;
      padding: 4px 12px 0px 0px;
    }
  }
}
.chip {
  margin-top: -1px;
}
.clear {
  clear: both;
}
.small-icon {
  font-size: 13pt;
  margin-right: 4px;
}
.select-button {
  width: 90%;
  margin-left: 5%;
}
.name {
  font-size: 12pt;
}
.case-number-label {
  cursor: pointer;
}
.case-driving {
  cursor: pointer;
  font-size: 8pt !important;
  text-align: left !important;
}
.task-detail {
  margin-bottom: 0px !important;
  margin-top: 8px !important;
}
.blank {
  height: 64px;
  background-color: #0a3444;
}
.top-toolbar {
  height: 56px;

  &-button {
    margin-top: -2px;
  }
  &-textfield {
    margin-top: 4px;
  }
}
.task-rest {
  font-size: 16pt !important;
  color: rgb(223, 223, 223) !important;
}
.sup-name {
  text-align: left !important;
  padding-left: 8px;
  color: #1976d2 !important;
}
.para {
  margin-bottom: 4px !important;
  font-weight: normal !important;
  text-align: left !important;
  padding-left: 8px;
}

.date-picker {
  margin-right: 12px !important;
}
.v-btn--active {
  opacity: 1;
  background: #c7c7c7;
}
.dispatch-dialog {
  z-index: 300 !important;
}
.vehicle-icon {
  font-size: 11pt;
}
.btn-group {
  margin-top: -8px;
  margin-right: 4px;
}
.toolbar-item {
  width: 200px !important;
  margin-left: 8px !important;
  margin-top: 4px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/monitor/components/Tasks.vue